(function () {
  'use strict';

  if (document.body.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;

  function initScrollAnimations() {
    // Target sections within main content — try both direct children and nested
    var sections = Array.from(
      document.querySelectorAll('#MainContent .shopify-section')
    );

    // Fallback: target direct children of main if shopify-section not found
    if (!sections.length) {
      var main = document.getElementById('MainContent');
      if (main) sections = Array.from(main.children);
    }

    if (!sections.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -48px 0px'
    });

    sections.forEach(function (section, index) {
      var rect = section.getBoundingClientRect();
      var isAboveFold = rect.top < window.innerHeight && rect.bottom > 0;

      // Only animate sections that start below the visible viewport
      if (!isAboveFold) {
        section.classList.add('at-fade');
        if (index % 3 === 1) section.classList.add('at-fade-delay-1');
        if (index % 3 === 2) section.classList.add('at-fade-delay-2');
      }

      observer.observe(section);
    });
  }

  // Run after full page load so layout is settled and getBoundingClientRect is accurate
  if (document.readyState === 'complete') {
    initScrollAnimations();
  } else {
    window.addEventListener('load', initScrollAnimations);
  }
})();
